import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isTrue',
  standalone: true,
})
export class IsTruePipe implements PipeTransform {
  public transform(value: unknown): boolean {
    return value === true;
  }
}
